



















import LocationSearchControl from '@/components/common/LocationSearchControl.vue';
import ParameterHelp from '@/components/estimates/common/ParameterHelp.vue';
import EstatesMap from '@/components/maps/EstatesMap.vue';
import {Place} from '@/components/maps/Place';
import {EstimateEstateType, Location, RealEstateEstimateState} from '@/model/api';
import {Estimate} from '@/model/Estimate';
import {EVENT_LOCATION_VALIDATED, EventBus} from '@/model/events';
import {left, right} from 'fp-ts/lib/Either';
import {isEqual} from 'lodash-es';
import {Component, Inject, Prop} from 'vue-property-decorator';
import Segment from './Segment';

@Component({
    components: {LocationSearchControl, EstatesMap, ParameterHelp},
})
export default class LocationSegment<T extends RealEstateEstimateState> extends Segment<T> {
    @Inject()
    public readonly eventBus: EventBus;

    @Inject()
    public readonly model: Estimate<T>;

    @Prop({required: true})
    public readonly defaultValue: Location | null;

    @Prop({type: String, required: true})
    public readonly estateType: EstimateEstateType;

    public get invalid(): boolean {
        return this.validate && this.value === null;
    }

    public searchResults: Location[] = [];

    public validate: boolean = false;

    protected value: Location | null = null;

    private clearCounter: number = 0;

    private originalValue: Location | null = this.defaultValue;

    protected get selectedPlace(): Place | null {
        const value = this.value;

        if (value === null) {
            return null;
        }

        const point = value.center;

        if (point === null) {
            return null;
        }

        return {
            title: value.name,
            coordinates: [point.coordinates[1], point.coordinates[0]],
        };
    }

    public created() {
        this.value = this.defaultValue;
        this.originalValue = this.defaultValue;
    }

    public mounted(): void {
    }

    public async submit() {
        const value = this.value;

        if (value === null) {
            this.validate = true;

            return left(null);
        }

        this.eventBus.emit(EVENT_LOCATION_VALIDATED, value);

        const estimate = await this.model.selectLocation(value);

        this.validate = false;
        this.originalValue = this.value;

        return right(estimate);
    }

    public hasNotSubmittedChanges(): boolean {
        return ! isEqual(this.value, this.originalValue);
    }

    public clearNotSubmittedChanges(): void {
        this.value = this.originalValue;
        this.clearCounter++;
    }

    public onInput(value: Location): void {
        this.value = value;
    }

    public allowsMovingOn(): boolean {
        return this.defaultValue !== null;
    }
}
